$(".data-share-popup").on(
    "click",
    function (event) {
        sharePopup($(this).attr("href"));
        event.preventDefault();
    }
);

function sharePopup(href) {
    width = 555;
    height = 600;
    leftPosition = window.screen.width / 2 - (width / 2 + 10);
    topPosition = window.screen.height / 2 - (height / 2 + 50);

    var windowFeatures =
        "status=no,height=" +
        height +
        ",width=" +
        width +
        ",left=" +
        leftPosition +
        ",top=" +
        topPosition +
        ",screenX=" +
        leftPosition +
        ",screenY=" +
        topPosition +
        ",,resizable=1toolbar=no,menubar=no,scrollbars=no,location=no,directories=no";

    var title = "Share";
    window.open(href, title, windowFeatures);
    return false;
}

